import 'zone.js/plugins/zone-error';

export const environment = {
  production: false,
  appVersion: require('../../package.json').version,
};
